module.exports = __webpack_public_path__ + "img/Collaboration.56f96873.gif";